module.exports = __webpack_public_path__ + "annualreview2017/static/img/connected-technology-and-microgeneration@2x.05dd544.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/landscape/connected-technology-and-microgeneration@2x.png
// module id = 315
// module chunks = 0